import React, { useRef } from "react";
import { useReactToPrint } from 'react-to-print';

class PrintCorte extends React.PureComponent{
	constructor(props){
	   super(props);
	
	   this.state = {
		  fecha : null,//props.laFecha,
		  lista_corte : [],
		  cambios : []
	   }
	}
	componentDidMount(){
	   let fecha = new Date();
	   let month = fecha.getMonth() + Number(1);
		 month = month < 10 ? '0'+month : month;
		 fecha = fecha.getDate()+'/'+month+'/'+fecha.getFullYear();
	   this.setState({fecha});
	   
	}
	render(){
	
	   let { data } = this.props;
	   const sesion = JSON.parse( localStorage.getItem('sesion') );
	   
	   const th = {
			 fontSize : '10px'
		 }
	   let trGastos=[]; 
	   if( data.gastos.length > 0 ){
		  
		  data.gastos.forEach((g,indice)=>{
			// totalGastos = totalGastos + parseFloat(g.costo);
			 trGastos.push(
				<tr key={indice}>
				   <td style={th}>{g.descripcion}</td>
				   <td style={th}>{window.$fmoney(g.costo,2)}</td>
				</tr>
			 );
		  });
	   }
	   let total2 = Number( data.mayoreo ) + Number( data.menudeo );
	//    let totalCajaGeneral = total2 - totalGastos;
	   let hora = new Date();
	  

	   return (
		  <div className="ticket ticket2">
		  <table className='table-bootstrap'>
			 <tbody>
				<tr>
				   <td colSpan='2' style={th} className='text-center'>
					  <h5>{sesion.sucursal_name}</h5><br></br>
					  <small dangerouslySetInnerHTML={{ __html: sesion.encabezado_ticket}}></small><br/>
					  <small style={{'position':'relative','marginTop':'5px'}}>Hora de corte: {hora.toLocaleTimeString()}</small>
				   </td>
				</tr>
				<tr>
				   <td style={th}>Fecha de corte</td>
				   <td style={th}>{data.fecha}</td>
				</tr>
				<tr>
				   <td style={th}>Venta Total</td>
				   <td style={th}>{ window.$fmoney(total2,2)}</td>
				</tr>

				{/* <tr style={{display: (sesion.rol!=='2'&&'none')}}>
				   <td style={th}>Egresos total</td>
				   <td style={th}>{ window.$fmoney( totalGastos, 2) }</td>
				</tr> */}
				{/* <tr>
				   <td style={th} colSpan={2}>Egresos</td>
				</tr>
				{sesion.rol=== 2 && trGastos} */}
				{/* <tr style={{display: (sesion.rol!=='2'&&'none')}}>
				   <td style={th}>Total caja</td>
				   <td style={th}>{ window.$fmoney( totalCajaGeneral, 2) }</td>
				</tr> */}
				
				<tr style={{display: (sesion.rol!== 2 && 'none' )}}>
				   <td style={th}>Mayoreo</td>
				   <td style={th}>{ data.cantMayoreo }</td>
				</tr>
				<tr style={{display: (sesion.rol!== 2 && 'none')}}>
				   <td style={th}>Cambios</td>
				   <td style={th}>{ data.cambios }</td>
				</tr>
				<tr><td>Cantidad</td><td>Total</td></tr>
				{/* <tr><td style={th} colSpan={2}>Venta con Tarjeta</td></tr> */}
				
				{/* <tr><td style={th}> { data.tarjeta[0] } </td><td style={th}> { window.$fmoney(data.tarjeta[1],2) } </td></tr> */}

				<tr><td style={th} colSpan={2}>Venta en efectivo</td></tr>
				{/* <tr><td>Cantidad</td><td>Total</td></tr> */}
				<tr>
				   	<td style={th}>{data.efectivo[0]}</td>
					<td>{window.$fmoney(data.efectivo[1],2)}</td>
				</tr>
			 </tbody>
		  </table>
		  </div>
	   )
	}
}

const HojaReporte = ({data, fecha, open, setOpen}) => {
	
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		 content : () => componentRef.current
	});
	
	return (
	   <div className={ open ? 'corte show' : 'corte'}>
		  <div className='box-corte'>
			 <h4>Corte de caja <span className='close' onClick={()=>setOpen(!open)}>x</span></h4>
			 <div className='row'>
				<div className='xs-12 sm-12 md-12 lg-12 child-center'>
				   <div className='btn btn-green btn-small' onClick={handlePrint}>Imprimir</div>
				</div>
			 </div>
			 <PrintCorte ref={componentRef} data={data} laFecha={fecha}/>
		  </div>
	   </div>
	)
}

export {PrintCorte, HojaReporte};